
import React, { useEffect, useState } from 'react';
import './index.css'
import { TicketMultipleUpdateFormModel } from '../../../../models/ticket.model';
import { useProject } from '../../../../context/ProjectContext';
import Autocomplete from '../../../common/Autocomplete';
import RichEditor from '../../../common/RichEditor';
import FormSection, { FormElement } from '../../../common/FormSection';
import { getTicketPriorities, getTicketStatus } from '../../../../services/autocomplete.service';
import { useNotification } from '../../../../context/NotificationContext';


interface TicketUpdateMultipleProps {
  setLoadingData: (p: boolean) => void
  ticketMultipleUpdateForm: TicketMultipleUpdateFormModel
  setTicketMultipleUpdateForm: (p: any) => void
  action: string
  setConfirmDisabled?: (p: boolean) => void
}

const TicketUpdateMultiple: React.FC<TicketUpdateMultipleProps> = ({
  setLoadingData,
  ticketMultipleUpdateForm,
  setTicketMultipleUpdateForm,
  action,
  setConfirmDisabled,
}) => {

  const { description, priority, status } = ticketMultipleUpdateForm;
  const { selectedProject } = useProject()
  const { showNotification } = useNotification();

  const [statusList, setStatusList] = useState([]);
  const [prioritiesList, setPrioritiesList] = useState([]);


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setTicketMultipleUpdateForm({
      ...ticketMultipleUpdateForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setTicketMultipleUpdateForm({
      ...ticketMultipleUpdateForm,
      [key]: value
    });
  }

  const initComponent = () => {
    setLoadingData(true)
    if (action === "create") {
      Promise.all([
        getTicketStatus(selectedProject),
        getTicketPriorities(selectedProject),
      ]).then(function (result) {
        setStatusList(result[0])
        setPrioritiesList(result[1])
        setLoadingData(false)
      }).catch((error) => {
        setLoadingData(false)
        showNotification(error.response.data)
      });
    }
  };

  useEffect(initComponent, [])

  const formHasErrors = () => {
    const op1: boolean = ticketMultipleUpdateForm['description'].replace('<p><br></p>', '') === ''
    const op2: boolean = !ticketMultipleUpdateForm['priority'] || ticketMultipleUpdateForm['priority'].id === ''
    const op3: boolean = !ticketMultipleUpdateForm['status'] || ticketMultipleUpdateForm['status'].id === ''

    setConfirmDisabled?.(op1 && op2 && op3)

  }

  useEffect(formHasErrors, [description, priority, status])

  return (
    <React.Fragment>
      <div className='multiple-action-modal-section'>
        <FormSection>
          <FormElement>
            <div className='tkt-form-section'>
              <div className='tkt-form-section-title'>
                <p>DATOS BÁSICOS</p>
              </div>

              <div className='tkt-form-section-item'>
                <Autocomplete
                  label='Prioridad'
                  placeholder='Prioridad'
                  name='priority'
                  disabled={action === "view"}
                  options={prioritiesList}
                  value={ticketMultipleUpdateForm.priority}
                  handleSelection={handleSelection}
                />
              </div>

              <div className='tkt-form-section-item'>
                <Autocomplete
                  label='Estado'
                  placeholder='Estado'
                  name='status'
                  disabled={action === "view"}
                  options={statusList}
                  value={ticketMultipleUpdateForm.status}
                  handleSelection={handleSelection}
                />
              </div>

            </div>
          </FormElement>

          <FormElement>

            <div className='tkt-form-section'>
              <div className='tkt-form-section-title'>
                <p>DESCRIPCIÓN</p>
              </div>
              <div className='tkt-form-section-item__desc'>
                <RichEditor
                  name="description"
                  value={ticketMultipleUpdateForm.description}
                  disabled={action === "view"}
                  handleChange={handleChange}
                />
              </div>
            </div>
          </FormElement>

        </FormSection>

      </div>
    </React.Fragment>
  )
}




export default TicketUpdateMultiple